import { useDispatch } from 'react-redux';

import SessionClientDashboard from 'dashboard/lib/clients/SessionClientDashboard';
import { MessageType } from 'dashboard/lib/interfaces/Message';
import { SimulateCustomPreset } from 'dashboard/models/simulate/preset';
import { showMessage } from 'dashboard/redux/actions/messages';
import useApiCallback from 'lib/hooks/useApiCallback';
import useApiErrorHandler from 'lib/hooks/useApiErrorHandler';
import { ApiEndpoint } from 'lib/interfaces/api';
import { isPermissionsError, permissionsErrorMessage } from 'lib/permissions-errors';

export default (): {
  handleArchiveSimulatePreset: (presetId: string) => Promise<void>;
  loadingArchiveSimulatePreset: boolean;
} => {
  const dispatch = useDispatch();

  const {
    loading: loadingArchiveSimulatePreset,
    error: handleArchiveSimulatePresetError,
    callback: handleArchiveSimulatePreset,
  } = useApiCallback(async (presetId: string) => {
    const { data: simulateCustomPreset } =
      await SessionClientDashboard.deleteResource<SimulateCustomPreset>(
        ApiEndpoint.SimulatePreset,
        presetId,
      );

    dispatch(
      showMessage(
        `Preset "${simulateCustomPreset.attributes.name}" has been successfully deleted.`,
        MessageType.Success,
      ),
    );
  }, []);

  useApiErrorHandler({
    error: handleArchiveSimulatePresetError,
    onError: (error) => {
      if (isPermissionsError(error)) {
        dispatch(showMessage(permissionsErrorMessage(error), MessageType.Failure));
      }

      dispatch(showMessage('Failed to delete preset.', MessageType.Failure));
    },
    onNetworkError: () =>
      dispatch(
        showMessage('We are experiencing network issues. Please try again.', MessageType.Failure),
      ),
  });

  return {
    loadingArchiveSimulatePreset,
    handleArchiveSimulatePreset,
  };
};
